import React, { useState } from 'react';

import { Col, Form, Input, Row, Upload, Button } from 'antd';

import { UploadOutlined } from '@ant-design/icons';
import UploadBoardFile from 'src/components/common/UploadBoardFile';

const CreateBoardForm = ({ handleFileValue, form }) => {
  const [fileList, setFileList] = useState([]);

  const props = {
    multiple: true,
    onRemove: (file) => {
      setFileList((prev) => {
        const index = prev.indexOf(file);
        const newFileList = prev.slice();
        newFileList.splice(index, 1);
        return newFileList;
      });

      handleFileValue((prev) => {
        const index = prev.files.indexOf(file);
        const newFileList = prev.files.slice();
        newFileList.splice(index, 1);

        return {
          ...prev,
          files: newFileList,
        };
      });
    },
    beforeUpload: (file) => {
      setFileList((prev) => [...prev, file]);
      handleFileValue((prev) => ({
        ...prev,
        files: [...prev.files, file],
      }));
      return false;
    },
    fileList,
  };

  return (
    <>
      <Row justify="center">
        <Col span={18}>
          <Form.Item name="wr_subject" label="제목" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          {/* <Form.Item name="category" label="카테고리" rules={[{ required: false }]}>
            <Col span={10}>
              <Input />
            </Col>
          </Form.Item> */}

          <Form.Item name="wr_content" label="내용" rules={[{ required: true }]}>
            <Input.TextArea autoSize={{ minRows: 6 }} />
          </Form.Item>

          <Form.Item label="Upload File" valuePropName="files" style={{ marginBottom: 5 }}>
            <Upload {...props} name="files">
              <Button icon={<UploadOutlined />}>Select File</Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default CreateBoardForm;
